/**
 * Export annotation blocks (scope declaration, value legend) as the CSV and XLSX exports
 * write them. The server export of the matching screen and the browser export of the
 * transactions screen render the SAME block the SAME way, so the layout lives once here.
 */

/** Un par etiqueta/valor de un bloque, ya traducido y listo para escribirse. */
export type ExportAnnotationRow = readonly [label: string, value: string]

/** El escapador del propio generador (RFC 4180 + neutralización de fórmulas). */
export type CsvValueEscaper = (value: string, separator: string) => string

/**
 * Las líneas que el CSV añade al final: una en blanco, el encabezado, y un
 * `etiqueta<sep>valor` por par. Lista vacía → el fichero sale como salía.
 */
export function buildAnnotationBlockCsvLines(
  rows: readonly ExportAnnotationRow[],
  heading: string,
  separator: string,
  escapeCsvValue: CsvValueEscaper,
): string[] {
  if (rows.length === 0) return []

  const lines = ['', escapeCsvValue(heading, separator)]
  for (const [label, value] of rows) {
    lines.push(`${escapeCsvValue(label, separator)}${separator}${escapeCsvValue(value, separator)}`)
  }
  return lines
}

/**
 * La rejilla de una hoja XLSX: cabecera localizada más un par por fila. Se
 * devuelve como array-of-arrays porque `aoa_to_sheet` respeta el orden, mientras
 * que `json_to_sheet` lo deriva de las claves del objeto. Vacío → el libro no
 * gana ni una hoja.
 */
export function buildAnnotationBlockSheetGrid(
  rows: readonly ExportAnnotationRow[],
  metricHeader: string,
  valueHeader: string,
): string[][] {
  if (rows.length === 0) return []
  return [[metricHeader, valueHeader], ...rows.map(([label, value]) => [label, value])]
}
